import gql from 'graphql-tag';

export default gql`
  query allRoles($first: Int!, $page: Int, $id: ID) {
    allRoles(
      first: $first
      page: $page
      id: $id
      orderBy: { field: "id", order: DESC }
    ) {
      paginatorInfo {
        count
        total
        currentPage
      }
      data {
        id
        name
      }
    }
  }
`;
